'use strict';

export default class ListController {

  /*@ngInject*/
  constructor($http, $stateParams, $state) {
    this.$http = $http;
    this.$stateParams = $stateParams;
    this.$state = $state;
  }

  $onInit() {
    this.getReports();
  }

  getReports() {
    this.page = this.$stateParams.page || 1;
    this.params = {
      page: this.page,
      limit: 30
    };
    if (this.$stateParams.search) {
      this.searchArgs = this.$stateParams.search;
      this.params.search = this.searchArgs;
    }
    this.$http.get('/api/reports', {params: this.params}).then(response => {
      this.reports = response.data;
    });
  }

  previousPage() {
    if (this.page == 0) {
      return;
    }
    this.page--;
    this.$state.go('main.list', {page: this.page, search: this.searchArgs});
  }

  nextPage() {
    this.page++;
    this.$state.go('main.list', {page: this.page, search: this.searchArgs});
  }

  delete(id) {
  if (confirm("确定？")) {
      this.$http.delete(`/api/reports/${id}`).then(response => {
        this.getReports();
      });
    }
  }

  search() {
    // this.page = this.$stateParams.page || 1;
    // var params = {
    //   page: this.page,
    //   search: this.searchArgs || ""
    // };
    // this.$http.get('/api/reports/search', {params: params}).then(response => {
    //   this.reports = response.data;
    // });
    this.$state.go('main.list', {page: this.page, search: this.searchArgs});
  }

  sendMail(id) {
    this.$http.get(`/api/reports/${id}/mail`).then(response => {
      console.log('ok');
    });
  }

  pageChanged() {
    this.$state.go('main.list', { page: this.page, search: this.searchArgs });
  }

  syncToRedmine(id) {
    this.$http.post('/api/reports/syncToRedmineByIds', {ids: [id]}).then(res => {
      this.$state.go('main.list', {page: this.page, search: this.searchArgs});
    })
  }

}



// WEBPACK FOOTER //
// ./client/app/main/list/list.controller.js